<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="primary">
          mdi-file-document
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Leave Details"
      text="Details"
      class="mb-0"
    > 
      <v-container>
        <v-row no-gutters>
          <v-col
            v-for="document in documents"
            :key="document.id"
            cols="12"
            class="my-1"
          >
            <v-chip
              color="blue-grey lighten-3"
              link
              style="width: 100%;"
              :href="document.file_url"
              target="_blank"
            >
              <v-icon
                color="red"
                left
              >
                mdi-file-pdf
              </v-icon>
              <span class="text-truncate"> {{ document.file_name }} </span>
            </v-chip>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      leaveApplication: {
        type: Object,
        required: true,
      },
    },

    data () {
      return {
        dialog: null,
        documents: [],
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return       
        this.loadOnBehalfLeaveApplicationDocument(this.leaveApplication)
      },
    },

    methods: {
      loadOnBehalfLeaveApplicationDocument (item) {
        this.$api.onBehalfLeaveApplications().show(item.id)
          .then(res => {
            this.documents = res.data[0].documents
          })
      },  
    },
  }
</script>
